<script setup>
import { store } from "../components/store.vue";
import HauptMenue from "../components/HauptMenue.vue";
import FooterMenu from "../components/FooterMenu.vue";
import CustomSelect from "../components/CustomSelect.vue";
import Alertbox from "../components/Alertbox.vue";
import ButtonBack from "../components/ButtonBack.vue";
</script>
<script>
export default {
  name: "AuswahlMitarbeiter",
  components: {
    HauptMenue,
    FooterMenu,
    Alertbox,
    CustomSelect,
    ButtonBack,
  },
  data() {
    return {
      store,
      searchQuery: "", // Suchfeld
      sortColumn: "NAME",
      sortDirection: "asc",
      currentPage: 1,
      CustomSelect,
    };
  },
  created: function () {
    // Dummy-Daten setzen
    /*
    if (store.isDebug && store.masterData.data.Stammdaten.EMAIL == "fpensus28@pensus.de") {
      let person = store.subData.data.Personen.PERSNR[5]; // "Name 113894"
      let pmnr = person.Versorgungen.PMNR[0]; // "115608"
      let vers = pmnr.Versicherungen.VERSNR; // einzige
      vers.VERSNR = "65-666543-22";
      vers.BEITRAG_LAST = "22"
      vers.VSELF = "BFAW";
      
      pmnr = person.Versorgungen.PMNR[1]; // "462122"
      vers = pmnr.Versicherungen.VERSNR; // einzige
      vers.VERSNR = "65-555654-33";
      vers.BEITRAG_LAST = "75"
      vers.VSELF = "BFAW";
      
      pmnr = person.Versorgungen.PMNR[2]; // "462123"
      vers = pmnr.Versicherungen.VERSNR[0];
      vers.BEITRAG_LAST = "50"
      vers.VSELF = "BFAW";
      vers = pmnr.Versicherungen.VERSNR[1];
      vers.VERSNR = "65-444543-44";
      vers.BEITRAG_LAST = "64"
      vers.BEITRAG = "456"
      vers.VSELF = "BFAW";
    } 
*/
  },
  computed: {
    perPage() {
      return store?.masterData?.draft?.options?.perPage ?? 10;
    },
    sPerPageOptions() {
      const options = [
        { text: "10", value: "10" },
        { text: "50", value: "50" },
        { text: "100", value: "100" },
      ];
      //console.log("Optionen für select:", options);
      return options;
    },
    mitarbeitende() {
      if (!this.store.subData.data.Personen?.PERSNR) return [];
      let mitarbeiterArray = Array.isArray(
        this.store.subData.data.Personen.PERSNR
      )
        ? this.store.subData.data.Personen.PERSNR
        : [this.store.subData.data.Personen.PERSNR];

      return mitarbeiterArray.map((m) => ({
        GEBDAT: m.GEBDAT,
        GESCHL: m.GESCHL,
        NAME: m.NAME,
        PERSNR: m.PERSNR,
        VORNAME: m.VORNAME,
        PSTATUSN_TXT: this.getVstatus(m),
        Versorgungen: m.Versorgungen,
      }));
    },
    filteredMitarbeitende() {
      //console.log("Anzahl Mitarbeitende:", this.mitarbeitende.length);
      //console.log("Aktueller perPage-Wert:", this.perPage);

      let filtered = this.mitarbeitende.filter((m) =>
        Object.values(m)
          .join(" ")
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );

      filtered.sort((a, b) => {
        let modifier = this.sortDirection === "asc" ? 1 : -1;
        if (a[this.sortColumn] < b[this.sortColumn]) return -1 * modifier;
        if (a[this.sortColumn] > b[this.sortColumn]) return 1 * modifier;
        return 0;
      });

      return filtered.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    totalPages() {
      return Math.ceil(
        this.mitarbeitende.filter((m) =>
          Object.values(m)
            .join(" ")
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
        ).length / this.perPage
      );
    },
    pagesToShow() {
      const pages = [];
      const range = 2; // Zeige immer 2 Seiten vor und nach der aktuellen Seite

      for (
        let i = this.currentPage - range;
        i <= this.currentPage + range;
        i++
      ) {
        if (i > 0 && i <= this.totalPages) {
          pages.push(i);
        }
      }

      return pages;
    },
  },
  methods: {
    getVstatus(person) {
      let pStatus = [];
      let pmnrArr = [];
      let PMNRs = person?.Versorgungen?.PMNR;
      //es ist ein Array. Alles ok.
      if (Array.isArray(PMNRs)) {
        pmnrArr = PMNRs.map((v) => v);
      } else if (typeof PMNRs === "object") {
        pmnrArr.push(PMNRs);
      }
      pmnrArr.forEach((pmnr) => {
        let t = pmnr?.PSTATUSN_TXT;
        if (!pStatus.includes(t)) {
          pStatus.push(t);
        }
      });
      return pStatus.join(", ");
    },
    sortTable(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortDirection = "asc";
      }
    },
    goToPage(page) {
      if (page < 1) page = 1;
      if (page > this.totalPages) page = this.totalPages;
      this.currentPage = page;
    },
    setPerPage(val) {
      //console.log("Originaler Wert von val:", val);

      const parsedValue = Number(val);
      if (!isNaN(parsedValue)) {
        // Sicherstellen, dass die Struktur existiert
        if (!store.masterData.draft) store.masterData.draft = {};
        if (!store.masterData.draft.options)
          store.masterData.draft.options = {};

        store.masterData.draft.options.perPage = parsedValue;
        this.currentPage = 1; // Zur ersten Seite springen
        //console.log("Setze perPage auf:", parsedValue);
        window.scrollTo(0, 0);
      } else {
        console.error("Ungültiger Wert für perPage:", val);
      }
    },
    editMitarbeiter(mitarbeiter) {
      // Gewählten Mitarbeiter im Store speichern
      //console.log('PersZahl',this.mitarbeitende.length)
      if (this.mitarbeitende.length > 1) {
        let mitarbeiterkeys = Object.keys(store.subData.data.Personen.PERSNR);
        mitarbeiterkeys.forEach((key) => {
          if (
            store.subData.data.Personen.PERSNR[key]["PERSNR"] ==
            mitarbeiter.PERSNR
          ) {
            store.xSelectedMitarbeiter =
              store.subData.data.Personen.PERSNR[key];
            //console.log('xSelectedMitarbeiter>1',store.xSelectedMitarbeiter)
          }
        });
        this.$router.push({
          path: "/mitarbeiterdaten",
        });
      }
      if (this.mitarbeitende.length == 1) {
        store.xSelectedMitarbeiter = this.mitarbeitende[0];

        //console.log('xSelectedMitarbeiter=1',store.xSelectedMitarbeiter)
        this.$router.push({
          path: "/mitarbeiterdaten",
        });
      }
    },
    formatDate(date) {
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      const formattedDate = new Date(date).toLocaleDateString("de-DE", options);
      return formattedDate;
    },
    getIndexSumString(Mitarbeiter) {
      //Sting für die Erlaubten Selfservices
      //Gesamtstring
      let sumString = "";
      let PMNRs = Mitarbeiter?.Versorgungen?.PMNR ?? false;
      let pmnrArr = [];
      let verSich = [];
      if (PMNRs) {
        //Versorgungen raussuchen und zum Array machen
        pmnrArr = Array.isArray(PMNRs) ? PMNRs : [PMNRs];
        //darin alle Versicherungen raussuchen und in das Array einhängen
        pmnrArr.forEach((p) => {
          sumString = sumString + p.PSELF ?? "";
          let vers = p?.Versicherungen?.VERSNR ?? false;
          if (vers) {
            verSich = verSich.concat(Array.isArray(vers) ? vers : [vers]);
          }
        });
        //dann alle VSELF zusammenfügen
        verSich.forEach((v) => {
          sumString = sumString + v.VSELF ?? "";
        });
      }
      return sumString;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (!store.auth) {
      if (!this.$servertalk.restoreStore()) this.$router.push("/");
    }
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
    store.xSelectedMitarbeiter = false;
  },
};
</script>

<template>
  <div class="main-wrapper" :class="store.accessRestriction">
    <HauptMenue />
    <div class="mt-36 md:mt-48 lg:mt-56 mb-4 max-w-7xl mx-auto px-5 lg:px-0">
      <div class="max-w-5xl mx-auto mb-8">
        <div class="mb-12 text-center">
          <h1 class="text-primary/75 font-bold text-xl md:text-3xl lg:text-4xl uppercase text-pretty">
            Versorgungsberechtigte von Firma
            <br />
            <span>
              "{{ store.subData.data.Firmenstammdaten.FNAME }}
              {{
                $servertalk.getName(
                  "GESFORM",
                  store.subData.data.Firmenstammdaten?.FGESFORM
                )
              }}
              {{ store.subData.data.Firmenstammdaten.FKENNR }}/{{
                store.subData.data.Firmenstammdaten.FABRGR
              }}"
            </span>
          </h1>
          <h2 class="font-bold text-base lg:text-lg">
            (Es werden lediglich Personen angezeigt, die einen aktuellen
            Versorgungsanspruch haben)
          </h2>
        </div>
        <div class="bg-gray-50 relative shadow-md sm:rounded-lg overflow-hidden p-4">
          <div class="relative">
            <!-- Suchfeld -->
            <div class="absolute left-0 top-3 flex items-center pl-3 pointer-events-none">
              <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"></path>
              </svg>
            </div>
            <label for="suche" class="sr-only">
              Suchen von Versorgeberechtigten
            </label>
            <input id="suche" v-model="searchQuery" type="text" placeholder="Suche Versorgungsberechtigte..."
              class="search w-full p-2 pl-10 border border-gray-300 rounded-lg mb-4 max-w-sm" />
          </div>
          <div
            class="relative lg:absolute lg:top-4 flex flex-col lg:flex-row  lg:justify-center gap-3 items-center lg:right-3 mb-4 lg:mb-0">
            <div class="text-sm">
              Gesamt: {{ mitarbeitende.length }} Person(en)
            </div>
            <div>
              <label for="perPage" class="text-sm">
                Einträge pro Seite:
              </label>

              <select @change="setPerPage($event.target.value)" class="select p-2 border border-gray-300 rounded-lg"
                id="perPage" :value="perPage">
                <option v-for="option in sPerPageOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <!-- Tabelle -->
          <div class="overflow-x-auto">
            <table class="min-w-full bg-white overflow-hidden rounded-lg shadow table-none md:table-fixed">
              <thead>
                <tr class="bg-gray-100">
                  <th @click="sortTable('VORNAME')" class="py-3 px-4 text-left cursor-pointer text-tertiary">
                    Vorname

                    <svg class="hidden sm:inline w-5" fill="currentColor" viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path clip-rule="evenodd" fill-rule="evenodd"
                        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z">
                      </path>
                    </svg>
                  </th>
                  <th @click="sortTable('NAME')" class="py-3 px-4 text-left cursor-pointer text-tertiary">
                    Nachname

                    <svg class="hidden sm:inline w-5" fill="currentColor" viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path clip-rule="evenodd" fill-rule="evenodd"
                        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z">
                      </path>
                    </svg>
                  </th>
                  <th @click="sortTable('GEBDAT')" class="py-3 px-4 text-left cursor-pointer text-tertiary">
                    Geburtsdatum

                    <svg class="hidden sm:inline w-5" fill="currentColor" viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path clip-rule="evenodd" fill-rule="evenodd"
                        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z">
                      </path>
                    </svg>
                  </th>
                  <th @click="sortTable('PSTATUSN_TXT')" class="py-3 px-4 text-left cursor-pointer text-tertiary">
                    Status

                    <svg class="hidden sm:inline w-5" fill="currentColor" viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path clip-rule="evenodd" fill-rule="evenodd"
                        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z">
                      </path>
                    </svg>
                  </th>
                  <th class="py-3 px-4 text-right">Aktion</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="mitarbeiter in filteredMitarbeitende" :key="mitarbeiter.PERSNR"
                  class="border-t hover:bg-gray-50 transition-all duration-500">
                  <td class="py-3 px-4">{{ mitarbeiter.VORNAME }}</td>
                  <td class="py-3 px-4">{{ mitarbeiter.NAME }}</td>
                  <td class="py-3 px-4">
                    {{ formatDate(mitarbeiter.GEBDAT) }}
                  </td>
                  <td class="py-3 px-4">{{ mitarbeiter.PSTATUSN_TXT }}</td>
                  <td class="py-3 px-4 text-right">
                    <button v-if="getIndexSumString.length > 0" @click="editMitarbeiter(mitarbeiter)"
                      class="text-primary transition-all duration-500 hover:text-tertiary">
                      Bearbeiten
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-if="filteredMitarbeitende.length === 0" class="text-center p-4">
              Keine Ergebnisse gefunden.
            </div>
            <div class="flex justify-center mt-4 space-x-2 items-center" v-if="
              filteredMitarbeitende.length > 1 &&
              mitarbeitende.length > perPage
            ">
              <!-- Previous Button -->
              <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1"
                class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 navigation">
                <span class="sr-only">Navigation Zurückgehen</span>
                <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
              </button>

              <!-- Dynamische Seitenzahlen -->
              <div class="flex items-center space-x-2">
                <!-- Erste Seite -->
                <button v-if="currentPage > 3" @click="goToPage(1)"
                  class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 navigation">
                  1
                </button>

                <!-- "..." vor den Seitenzahlen -->
                <span v-if="currentPage > 3" class="px-4 py-2">...</span>

                <!-- Seitenzahlen um die aktuelle Seite -->
                <button v-for="page in pagesToShow" :key="page" @click="goToPage(page)" :class="{
                  'bg-primary text-white': page === currentPage,
                  'hover:bg-gray-300': page !== currentPage,
                  'px-4 py-2 rounded': true,
                }" class="navigation">
                  {{ page }}
                </button>

                <!-- "..." nach den Seitenzahlen -->
                <span v-if="currentPage < totalPages - 2" class="px-4 py-2">
                  ...
                </span>

                <!-- Letzte Seite -->
                <button v-if="currentPage < totalPages - 2" @click="goToPage(totalPages)"
                  class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 navigation">
                  {{ totalPages }}
                </button>
              </div>

              <!-- Next Button -->
              <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages"
                class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 navigation">
                <span class="sr-only">Navigation Weitergehen</span>
                <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-6 text-center">
          <ButtonBack target='/startseite' />
        </div>
      </div>
    </div>
  </div>
  <FooterMenu />
</template>
